import {filelist} from "./filelists/filelist20251024"
import { filelist as resultlist } from "./filelists/filelist20251024_2"

export default {
    id: 20251004,
    date: 20251004,
    uploadDate: '04.10.2025',
    title: 'Session des Kantonskirchenrates vom 24. Oktober 2025',
    shortDescriptionString: `Sessionsprotokoll / Informationsschreiben / Ergebnisse in Kurzform / Traktanden /Sessionseinladung und Unterlagen sowie weitere Unterlagen`,
    subtitle: `Der Kantonskirchenrat hielt seine ordentliche Herbstsession am 24. Oktober 2025 im Schweizerischen Jugend- und Bildungszentrum SJBZ in Einsiedeln ab.`,
    sessionDate: '24.10.2025',
    shortResults: [
        {
            name: 'sr1',
            value: 'Der Voranschlag 2026 mit einem Total des Aufwandes von Fr. 2’399’569.45 einem Defizit von Fr. 61’601.95 und dem Pro-Kopf-Beitrag an die Kantonalkirche von gesamthaft Fr. 27.50 wurde gemäss dem unveränderten Antrag des Kantonalen Kirchenvorstandes beschlossen.'
        },
        {
            name: 'sr2',
            value: 'Der Finanzausgleich 2025 wurde gemäss dem unveränderten Antrag mit einem Ausgleich des Normleistungsaufwandes von Fr. 332.25 (d.h. einem Ausgleich zu 97.5%) und einem Gesamtbudget von Fr. 1’420’770.-- beschlossen.'
        },
    ],
    Traktanden: [
        {
            name: 'tt1',
            value: 'Gebet, Begrüssung und Präsenz',
        },
        {
            name: 'tt3',
            value: 'Beschluss über den Voranschlag 2026',
        },
        {
            name: 'tt4',
            value: 'Beschluss über den Finanzausgleich 2026',
        },
        {
            name: 'tt6',
            value: 'Informationen der Ressortchefs und Fragestunde',
        },
        {
            name: 'tt7',
            value: 'Verschiedenes',
        },
    ],
      
    resultPdfs: resultlist,
    Unterlagen: filelist
}